import type { NameLabelPair, OptionGroup } from '../types/index.noReact';
import { isOptionGroupArray } from './optGroupUtils';

export interface FieldOption {
  readonly value: string;
  readonly label: string;
}
export interface GroupedOption {
  readonly label: string;
  readonly options: readonly FieldOption[];
}

export const toOptions = (
  arr?: NameLabelPair[] | OptionGroup[]
): GroupedOption[] | FieldOption[] | [] =>
  isOptionGroupArray(arr)
    ? arr.map(og => ({
        label: og.label,
        options: og.options.map(opt => ({
          label: opt.label,
          value: opt.name,
        })),
      }))
    : Array.isArray(arr)
    ? arr.map(opt => ({
        label: opt.label,
        value: opt.name,
      }))
    : [];
